export const pageTitle = (title) => {
    return ( document.title = title + " - Expert Digital Marketing Solutions");
  }